import React, { useState } from 'react';
import { Icon as _Icon } from 'tmt-ui-kit';
import styled from 'styled-components';

const Container = styled.div`

`;

const TooltipContainer = styled.div`
  position: relative;
  z-index: 300;
`;

const TooltipPopup = styled.div`
  position: absolute;
  top: 9px;
  padding: 8px 16px;
  background-color: ${props => props.theme.white};
  border: 1px solid #e2ecf0;
  box-shadow: 0 7px 9px 0 rgba(0,0,0,0.04);
`;

const TriangleSVG = styled.svg`
  position: absolute;
  width: 20px;
  height: 10px;
`;

const Icon = styled(_Icon)`
  color: ${props => props.theme.orange} !important;
  cursor: pointer;
`;

/**
 * Tooltip components
 * Use for making tooltip that when user click it will show popup box with description text
 * @example
 * <Tooltip text="Hello World" />
 */
const Tooltip = props => {
  const [isShowTooltip, setIsShowTooltip] = useState(false);
  function toggle() {
    setIsShowTooltip(oldValue => !oldValue);
  }
  const { text, className } = props;
  return (
    <Container className={className}>
      <Icon name="information-v2" onClick={toggle} />
      {isShowTooltip && (
        <TooltipContainer>
          <TooltipPopup className="tooltip-popup">
            <p>{text}</p>
          </TooltipPopup>
          <TriangleSVG role="presentation" focusable="false">
            <path className="_1s2t3cl" d="M0,10 20,10 10,0z"></path>
            <path style={{ fill: 'white', stroke: '#e2ecf0' }} className="_c3dsty" d="M0,10 10,0 20,10"></path>
          </TriangleSVG>
        </TooltipContainer>
      )}
    </Container>
  );
};

export default Tooltip;
